import React from 'react';
import ReactDOM from 'react-dom';
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "bootstrap/dist/css/bootstrap.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import RouterComponent from './routes';
import TwoD from './pages/phonic_sound/parent';

import { createRoot } from 'react-dom/client';

createRoot(document.getElementById('root')).render(<React.StrictMode>
  <ToastContainer theme="colored" autoClose={1500} />
  <RouterComponent />

</React.StrictMode>);


// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>
// );

// ReactDOM.render(
//   // <GoogleOAuthProvider clientId="335251304717-j4jqv8dc0s8t0d0jbspu5i63q35ptj3i.apps.googleusercontent.com">
//   <React.StrictMode>
//     <ToastContainer theme="colored" autoClose={1500} />
//     <RouterComponent />

//   </React.StrictMode>,
//   document.getElementById("root")
// );

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
